import React from "react";
import { View, StyleSheet, Platform, Dimensions } from "react-native";
import { ModalType, useModalStore } from "./store/modalStore";
import { useThemeSettings } from "./ThemeProvider";
import { CustomIcon } from "./components/CustomIcon";
import { FOOTER_HEIGHT } from "./shared/constants/dimension";
import { FooterNavBackground } from "./components/FooterNavBackground";
import { RadialGradientBox } from "./components/RadialGradientBox";
import { ROUTES } from "./shared/constants/routes";
import ThinkOLogo from "./components/ThinkoLogo";
import { TrackedTouchable } from "./analytics/components";
import TourStep from "./components/productTours/TourStep";
import { useSafeAreaInsets } from "react-native-safe-area-context";

export default function FooterNav({ state, descriptors, navigation }) {
    const footerNavs = [ModalType.LANGUAGES, ModalType.AI_ASSISTANT, ModalType.MENU];
    const setModalShown = useModalStore((state) => state.setModalShown);
    const { theme } = useThemeSettings();
    const insets = useSafeAreaInsets();

    const getIcon = (modalName: any) => {
        switch (modalName) {
            case ModalType.LANGUAGES:
                return <CustomIcon icon="translate" size={24} color={theme?.colors?.primary} />
            case ModalType.MENU:
                return <CustomIcon icon="menu" id="profile" size={24} color={theme?.colors?.primary} />
            case ModalType.AI_ASSISTANT:
                return <RadialGradientBox>
                    <ThinkOLogo size={65} thick />
                </RadialGradientBox>
        }
    }
    return (
        <View style={styles.wrapper}>
            {/* SVG BACKGROUND */}
            <FooterNavBackground />
            {/* ACTUAL TAB BUTTONS */}
            <View style={[styles.content, Platform.OS !== 'web' && { bottom: insets.bottom }]}>
                {footerNavs.map((item) => {
                    const isCenter = item === ModalType.AI_ASSISTANT;
                    const button = <TrackedTouchable context={{ cta: item }} id={item}

                        onPress={() => {
                            const route = state?.routes?.[state.index];
                            const articleId = route?.params?.articleId;
                            setModalShown(item, { articleId, showGeneralAssistant: route?.name === ROUTES.HOME })
                        }}
                        style={[
                            isCenter && styles.centerButton,
                            !isCenter && styles.iconButton,
                        ]}>
                        {(getIcon(item))}

                    </TrackedTouchable>;

                    if (item === ModalType.LANGUAGES) {
                        return <TourStep key={item} order={2}>{button}</TourStep>;
                    }

                    if (item === ModalType.AI_ASSISTANT) {
                        return <TourStep key={item} order={3}>{button}</TourStep>;
                    }

                    return <React.Fragment key={item}>{button}</React.Fragment>;
                })}
            </View>
        </View>
    );
}


const styles = StyleSheet.create({
    wrapper: {
        height: FOOTER_HEIGHT,
        position: Platform.OS === "web" ? "fixed" : "absolute",
        bottom: 0,
        left: 0,
        right: 0,
    },
    content: {
        height: FOOTER_HEIGHT,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-around",
        paddingBottom: Platform.OS === "web" ? 12 : 0,
    },
    iconButton: {
        padding: 10,
        marginTop: 10,
    },
    centerButton: {
        marginTop: -48,
    },
});
